import React, { useEffect, useState } from 'react';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CheckboxesGroup from './CheckboxesGroup';


export const StepTwo = ({ formData, updateFormData }) => {
  const [terms, setTerms] = useState(
    formData?.terms || "I hereby certify that all the information provided by me is true and accurate and I accept and understand that my data may be transferred for the purposes described above, to other Abbott group companies based in the United States of America."
  )
  const [acceptAllTerms, setAcceptAll] = useState(formData?.acceptAllTerms || false);

  useEffect(() => {
    updateFormData({
      terms,
      acceptAllTerms,
    })
  }, [terms, acceptAllTerms])


  const handleChangeSingle = (e) => {
    const { name, checked } = e.target
    if (name === "AcceptAllTerms") {
      setTerms(checked ? terms : "")
      setAcceptAll(checked)
      
    } 
  }

  return (
    <div className="px-4 flex justify-center gap-10 items-center StepTwoParent">
      <div className="w-[30%]">
        <CheckboxesGroup />
      </div>
      <div className="w-[70%] StepTwoContent mb-3 flex flex-column gap-4 items-start justify-between">
        <div>
          <h6>
            <b className="text-secondary">
              Due to the Financial Transparency and Disclosure guideline of - SFDA
            </b>
          </h6>
          <p className="text-secondary">
            It is obliged to document any Transfer of Value given to healthcare professionals and healthcare organizations and
            to publish them online.
          </p>

          <div className="w-100">
            <div>
              <b className="text-secondary">By accepting this,</b>
              <div>
                <p>{terms}</p>
              </div>
              <b>
                <a
                  href='https://www.arabia.abbott/en/privacy-policy.html'
                  target='_blank'
                  style={{
                    border: "none",
                    backgroundColor: "white",
                    color: "blue",
                    fontWeight: "600",
                    textAlign: "start",
                    textDecoration: "underline",
                  }}
                >
                  Abbott's Privacy Notice
                </a>
              </b>
            </div>
          </div>
          <div className="mt-2 flex-column flex-md-row d-flex justify-content-between align-items-center gap-2 w-100">
            <FormControlLabel
              className="AccpetAllTermsBox"
              control={
                <Checkbox
                  name="AcceptAllTerms"
                  checked={acceptAllTerms}
                  onChange={handleChangeSingle}
                />
              }
              label="Accept All Terms"
            />

            {!acceptAllTerms && (
              <p className="m-0 text-red-600 fs-6">
                Click accept to be able to continue
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}


